var map = {
	"./accept.svg": "ee64",
	"./background-modal.svg": "ba98",
	"./document-accept-1.svg": "4692",
	"./document-accept-2.svg": "4d93",
	"./document-accept-3.svg": "24a8",
	"./document-accept.svg": "db9c",
	"./document-nothing-1.svg": "64bb",
	"./document-nothing-2.svg": "897d",
	"./document-nothing-3.svg": "79f3",
	"./document-nothing.svg": "ce3c",
	"./document-reject-1.svg": "6726",
	"./document-reject-2.svg": "a3f4",
	"./document-reject-3.svg": "a7be",
	"./document-reject.svg": "7451",
	"./nothing.svg": "7331",
	"./reject.svg": "af9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2986";